import { useEffect } from 'react';
import './About.css';

export default function About() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="wrapper about-page">
      <div className="container">
        <div className="about-hero reveal">
          <div className="about-hero-text">
            <p className="sec-label">Our Story</p>
            <h1 className="sec-h2 about-h1">Zimbabwe's Premier<br />Tech Destination</h1>
            <p className="about-intro">LastTech was founded by Last Maisiri in Bindura with a simple mission: bring world-class tech gadgets to Zimbabweans at fair prices, with personal service that big stores can't match.</p>
            <p className="about-intro">From flagship iPhones to pro laptops, we source only genuine products and deliver them fast — right to your door anywhere in Zimbabwe.</p>
            <a href="https://wa.me/263713508064" target="_blank" rel="noreferrer" className="btn btn-wa" style={{marginTop:'1.5rem',display:'inline-flex'}}>
              📱 Chat with Last — +263 713 508 064
            </a>
          </div>
          <div className="about-hero-visual">
            <div className="about-visual-card">
              <div className="avc-icon">⚡</div>
              <div className="avc-name">LASTTECH</div>
              <div className="avc-tagline">Zimbabwe's Tech Store</div>
              <div className="avc-location">📍 Bindura, Zimbabwe</div>
            </div>
          </div>
        </div>

        <div className="about-values reveal">
          <p className="sec-label">What We Stand For</p>
          <h2 className="sec-h2">Our Values</h2>
          <div className="values-grid">
            {[
              { num:'01', title:'100% Genuine',    desc:'Every product we sell is original and comes with full manufacturer warranty. We never compromise on authenticity.' },
              { num:'02', title:'Personal Service', desc:'Last responds to every message personally. You get direct access to the owner, not a call centre.' },
              { num:'03', title:'Best Prices',      desc:'We work hard to offer the most competitive prices in Zimbabwe on all premium tech brands.' },
              { num:'04', title:'Fast Delivery',    desc:'Same-day delivery in Bindura. Nationwide delivery within 1-4 business days anywhere in Zimbabwe.' },
            ].map(v => (
              <div key={v.num} className="value-item">
                <div className="value-num">{v.num}</div>
                <div className="value-content">
                  <div className="value-title">{v.title}</div>
                  <p className="value-desc">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="about-stats reveal">
          {[
            { num:'2K+', label:'Happy Customers' },
            { num:'500+', label:'Products Available' },
            { num:'5★', label:'Average Rating' },
            { num:'24/7', label:'Support Available' },
          ].map(s => (
            <div key={s.label} className="astat">
              <div className="astat-num">{s.num}</div>
              <div className="astat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
